var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link_container"},_vm._l((_vm.filters),function(filter,index){return _c('span',{key:index,staticClass:"link",class:{
      'gold--text': _vm.activeFilter !== index,
      'selected--text': _vm.activeFilter === index
    },on:{"click":function($event){$event.stopPropagation();return _vm.filterClicked(filter.value, index)}}},[_vm._v("\n    "+_vm._s(filter.name)+"\n    "+_vm._s(filter.divider))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }